/**
 * useAnalytics V2 - React Hook for Analytics Operations
 *
 * CREATED: Issue #473 - V2 Repository Pattern
 * Analytics primitive (Position #22/25) - OPTIMIZE phase
 */

import { useMemo } from 'react';
import { useApolloClient } from '@apollo/client/react';
import { type ApolloClient } from '@apollo/client';
import { createAnalyticsRepositoryV2 } from '../data/repositories/primitives';
import { useCurrentTenant } from './useCurrentTenant';

export function useAnalytics() {
  const client = useApolloClient() as ApolloClient;
  const { tenantId } = useCurrentTenant();
  const repository = useMemo(() => createAnalyticsRepositoryV2(client), [client]);
  return { repository, tenantId };
}

